<template>
  <pnet-validation-observer>
    <label>
      <small>{{label}}</small>
    </label>
    <div class="row" v-if="gkid.costs != undefined && gkid.risk != undefined">
      <div class="col col-5">
        Costi del prodotto
        <div v-for="(cost, index) in gkid.costs" v-bind:key="index">
          <div class="row">
            <div class="col-5">
              <label>
                <small>minT{{index + 1}}</small>
              </label>
              <text-field v-model="cost.from"></text-field>
            </div>
            <div class="col-5">
              <label>
                <small>maxT{{index + 1}}</small>
              </label>
              <text-field v-model="cost.to"></text-field>
            </div>
          </div>
        </div>
      </div>
      <div class="col col-5">
        Fascia di rischio
        <div class="row">
          <div class="col-5">
            <label>
              <small>minR</small>
            </label>
            <text-field v-model="gkid.risk.from"></text-field>
          </div>
          <div class="col-5">
            <label>
              <small>maxR</small>
            </label>
            <text-field v-model="gkid.risk.to"></text-field>
          </div>
        </div>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import TextField from "@/components/TextField.vue";
export default Vue.extend({
  props: ["label", "value"],
  components:{
    TextField,
  },
  data: function() {
    return {
      gkid: {}
    }
  },
  mounted() {
    this.gkid = {
      order: 0,
      costs: [
        {
          from: "",
          to: ""
        },
        {
          from: "",
          to: ""
        },
        {
          from: "",
          to: ""
        }
      ],
      risk: {
        from: "",
        to: ""
      },
    };
    
  },
  methods: {},
  watch: {
    gkid: {
      deep:true,
      handler(){
        this.$emit('input', this.gkid);
      }
    },
    value: {
      handler(){
        this.gkid = this.value;
      }
    },
  },
});
</script>
